// src/utils/Onboarding/sync.js

import { getUtcIsoTimestamp } from './session.js';

export function buildSyncPayload(onboardingState) {
  if (!onboardingState) {
    return {
      session: null,
      fields: {},
      dirtyFields: [],
      generatedAt: getUtcIsoTimestamp(),
    };
  }

  return {
    session: {
      id: onboardingState.session?.id || null,
      createdAt: onboardingState.session?.createdAt || null,
      lastUpdatedAt: onboardingState.session?.lastUpdatedAt || null,
    },
    fields: { ...(onboardingState.latestValues || {}) },
    dirtyFields: Object.keys(onboardingState.dirtyFields || {}),
    generatedAt: getUtcIsoTimestamp(),
  };
}

export function computeLocalFingerprint(onboardingState) {
  if (!onboardingState) return null;
  try {
    const baseline = {
      sessionId: onboardingState.session?.id || null,
      lastUpdatedAt: onboardingState.session?.lastUpdatedAt || null,
      dirtyFields: Object.keys(onboardingState.dirtyFields || {}).sort(),
      latestValues: onboardingState.latestValues || {},
    };
    return JSON.stringify(baseline);
  } catch (error) {
    console.error('[OnboardingSync] Failed to compute fingerprint:', error);
    return null;
  }
}
